import React from 'react';
import { connect } from 'react-redux';
import { setClassNames } from '@ddc/classnames-js';
import PropTypes from 'prop-types';
import './CommonThumbnailButton.scss';

export class CommonThumbnailButtonContainer extends React.Component {
	render() {
		const {
			active,
			imageUrl,
			vehicle,
			labels,
			flags,
			buttonLabel,
			iconClass,
			isMobile,
			onClick,
			className
		} = this.props;

		const {
			make,
			model,
			year,
			type,
			bodyStyle,
			trim,
			certified,
			imgAttributes
		} = vehicle;

		const idcImgAttrFlag =
			flags['ws-vehicle-media-toggle-idc-image-attributes'];

		const typeTerm = type ? labels.get(certified ? 'CERTIFIED' : type) : '';
		const typeTermCapitalCase = typeTerm
			? typeTerm[0].toUpperCase() + typeTerm.substr(1).toLowerCase()
			: '';
		let imgAlt =
			`${typeTermCapitalCase} ${year} ${make} ${model} ${trim} ${bodyStyle}`.trim();
		if (idcImgAttrFlag) {
			imgAlt = imgAttributes?.imageAlt;
		}
		// inline styles to avoid CLS
		const imgStyles = {
			width: '100px'
		};
		const commonThumbnailButtonClasses = [
			'common-thumbnail',
			'text-link-muted'
		];

		const desktopThumbnailButtonClasses = [className];

		const mobileThumbnailButtonClasses = [className];

		return (
			<div
				className={setClassNames([
					...commonThumbnailButtonClasses,
					...(isMobile
						? mobileThumbnailButtonClasses
						: desktopThumbnailButtonClasses)
				])}
				onFocus={() => {}}
			>
				{!isMobile ? (
					<div className="common-thumbnail__img-container">
						<img
							style={imgStyles}
							role="presentation"
							src={imageUrl}
							alt={imgAlt}
							className={setClassNames([active ? 'active' : ''])}
							onClick={onClick}
						/>
						{iconClass ? (
							<i
								className={setClassNames([
									'ddc-icon',
									'ddc-font-size-xxlarge',
									iconClass
								])}
							/>
						) : null}
					</div>
				) : null}
				<p
					href="#"
					onClick={onClick}
					role="presentation"
					onFocus={() => {}}
					className={setClassNames([
						'common-thumbnail__label',
						'mb-0',
						'text-center',
						'ddc-font-size-small',
						'text-neutral-1000',
						isMobile && active ? 'active' : '',
						!isMobile ? 'mt-3 pt-2' : ''
					])}
				>
					{buttonLabel}
				</p>
			</div>
		);
	}
}

CommonThumbnailButtonContainer.propTypes = {
	active: PropTypes.bool.isRequired,
	imageUrl: PropTypes.string.isRequired,
	buttonLabel: PropTypes.string.isRequired,
	isMobile: PropTypes.bool.isRequired,
	onClick: PropTypes.func.isRequired,
	iconClass: PropTypes.string,
	className: PropTypes.string,
	vehicle: PropTypes.shape({
		make: PropTypes.string,
		model: PropTypes.string,
		year: PropTypes.string,
		type: PropTypes.string,
		bodyStyle: PropTypes.string,
		trim: PropTypes.string,
		certified: PropTypes.bool,
		imgAttributes: PropTypes.shape({
			imageAlt: PropTypes.string
		})
	}).isRequired,
	labels: PropTypes.shape({
		get: PropTypes.func
	}).isRequired,
	flags: PropTypes.shape({
		'ws-vehicle-media-toggle-idc-image-attributes': PropTypes.bool
	}).isRequired
};

CommonThumbnailButtonContainer.defaultProps = {
	iconClass: '',
	className: ''
};

const mapStateToProps = (state) => {
	const hasFirstImage = Boolean(
		state.media.images &&
			state.media.images.length > 0 &&
			state.media.images[0].thumbnail
	);
	const firstImage = hasFirstImage ? state.media.images[0].thumbnail : '';
	const isMobile = state.widgetInfo.deviceType === 'MOBILE';
	return {
		imageUrl: firstImage,
		isMobile,
		imagesCount: hasFirstImage ? state.media.images.length : 0,
		vehicle: state.widgetInfo.vehicle,
		flags: state.flags
	};
};

const ConnectedComponent = connect(
	mapStateToProps,
	{}
)(CommonThumbnailButtonContainer);
export default ConnectedComponent;
